// src/cms/boards/Board.jsx
import React, { useEffect, useMemo, useState } from "react";
import ConfirmModal from "../components/ConfirmModal";
import NewWindow from "../components/NewWindow";
import Paginator from "../components/Paginator";
import RichEditor from "../components/RichEditor";
import AttachmentBox from "../components/AttachmentBox";
import { apiAxios, apiAxiosMulti } from "../api/mockApi";
import { readSession, boardMasters } from "../auth/RequireAuth";

/* =========================
    샘플 데이터 + 로컬스토리지 CRUD
========================= */
const today = () => new Date().toISOString().slice(0, 10);
const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

// ★ 유틸: 사람이 읽기 좋은 파일 크기 표기
function formatBytes(bytes) {
    if (!bytes && bytes !== 0) return "";
    const units = ["B", "KB", "MB", "GB"];
    let i = 0, n = Number(bytes);
    while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
    return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

/** 수정 */
async function updatePost(patch, files, mod=false) {
    let url = "/scms/api/bbs/updateBoardArticle.do";
    if(mod) {
        url = "/scms/api/bbs/insertBoardArticle.do";
    }
    const requestBody = new FormData();
    const json = JSON.stringify(patch);
    const info = new Blob([json], { type: 'application/json' });
    requestBody.append("info", info);

    if(files != null) {
        for(const f of files) {
            requestBody.append("fileList", f.file);
        }
    }
    
    try{
        apiAxiosMulti(url, requestBody, function(res) {
            alert(res.message);
            window.location.reload();
        });
    } catch(e) {
        console.error(e);
    }

}
/** 삭제 */
async function deletePost(row) {
    const url = "/scms/api/bbs/deleteBoardArticle.do";
    const body = JSON.stringify({
        NTT_ID:  row.NTT_ID,
        BBS_ID:  row.BBS_ID,
        LAST_REGISTER_ID: JSON.parse(window.sessionStorage.getItem("userInfo")).uniqId,
    });
    
    apiAxios(url, body, function(res) {
        alert(res.message);
        window.location.reload();
    });
}

let currentBbsId = "";
// 동기화 useEffect 를 추가해서 item/currentType이 변할 때 폼/파일/편집상태를 초기화
/* ========================= UI 컴포넌트 ========================= */
function PostDetailPanel({ item, onClose, onSaved, onDeleted, currentType, portalTarget }) {
    const isQna = currentType === "BBSMSTR_BBBBBBBBBBBB";
    const buildDefault = () => ({
        ID: null,
        // BBS_ID: currentType,
        BBS_ID: currentBbsId,
        NTT_SJ: "",
        NTT_CN: "",
        ATCH_FILE: "", // 서버에선 첨부 ID 문자열일 수 있음
        USER_NM: userInfo.userNm,
        UNIQ_ID: userInfo.uniqId,
        REG_DT: today(),
    });
    const [form, setForm] = useState(item ? { ...item } : buildDefault());
    const [file, setFile] = React.useState(null);
    const [edit, setEdit] = React.useState(!item);
    const [askDelete, setAskDelete] = useState(false);

    // 동기화 useEffect를 추가해 item/currentType이 변할 떄 초기화
    // 🔁 item(상세 대상)이나 현재 탭이 바뀌면 폼/파일/편집 상태 초기화
    React.useEffect(() => {
        if (item) {
            setForm({ ...item });
            setEdit(false);        // 기존 글은 "읽기"로 시작
            setFile(null);
        } else {
            const d = buildDefault();
            // setForm(buildDefault(currentType, userInfo));
            setForm(d);
            setEdit(true); 
            setFile(null);
        }
    }, [item, currentType]);

    const set = (k, v) => setForm((s) =>  ({ ...s, [k]: v }));
    
    const save = async () => {
        setForm("UNIQ_ID", userInfo.uniqId);
        if (item?.ID) await updatePost(item.ID, form, file);
        else await updatePost(form, file, true);
        onSaved && onSaved();
    };

    const files = async () => {
        try {
            if(item != null) {
                const url = "/scms/api/bbs/selectFileList.do";
                const body = JSON.stringify({
                    ATCH_FILE_ID : item.ATCH_FILE,
                });
        
                apiAxios(url, body, function(res) {
                    setFile(res.list);
                });
            }
    
        } catch(e) {
            console.error(e)
        }
    };
    
    useEffect(() => {
        files();
    }, [item]);


    return (
        <div style={{ minWidth: "900px" }}>
            <div className="win-toolbar">
                <span className="title">{item ? "게시물 상세" : "게시물 등록"}</span>
                <div className="d-flex gap-2">
                {item && !edit && !isQna && (
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => setEdit(true)}>
                    <i className="fa-regular fa-pen-to-square me-1"></i>수정
                    </button>
                )}
                {!edit && item && (
                    <button className="btn btn-sm btn-outline-danger" onClick={() => setAskDelete(true)}>
                        <i className="fa-regular fa-trash-can me-1"></i>삭제
                    </button>
                )}
                <button className="btn btn-sm btn-secondary" onClick={onClose}>닫기</button>
                {edit && (
                    <button className="btn btn-sm btn-primary" onClick={save}>
                    <i className="fa-regular fa-floppy-disk me-1"></i>저장
                    </button>
                )}
            </div>
        </div>

        <div className="win-body">
            <div className="row g-3 input-rounded">
            <form id="editForm" encType="multipart/form-data"
                style={{ display: "flex", flexWrap:"wrap", gap:"1rem"}}>
                <div className="d-flex justify-content-between" style={{width: "100%"}}>
                    <div className="col-md-8">
                        <label className="form-label">{isQna ? "작성자" : "제목"}</label>
                        {edit ? (
                            <input
                                className="form-control"
                                value={isQna ? form.USER_NM : form.NTT_SJ}
                                onChange={(e) => set(isQna ? "USER_NM" : "NTT_SJ", e.target.value)}
                            />
                            ) : (
                            <div className="form-control bg-light">
                                {isQna ? form.USER_NM : form.NTT_SJ}
                            </div>
                        )}
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">{isQna ? "등록일" : "등록/수정일"}</label>
                        {edit ? (
                        <input
                            type="date"
                            className="form-control"
                            value={form.REG_DT?.slice(0, 10) || ""}
                            onChange={(e) => set("REG_DT", e.target.value)} disabled
                        />
                        ) : (
                        <div className="form-control bg-light">{form.REG_DT}</div>
                        )}
                    </div>
                </div>

                <div className="col-12">
                    <label className="form-label">{isQna ? "문의내용" : "내용"}</label>
                    {edit ? (
                        <RichEditor
                            value={form.NTT_CN || ""}
                            onChange={(html) => set("NTT_CN", html)}
                            minHeight={280}
                            placeholder={isQna ? "문의 내용을 입력하세요" : "게시물 내용을 입력하세요"}
                        />
                    ) : (
                    <div
                        className="form-control bg-light"
                        style={{ minHeight: 160, whiteSpace: "pre-line" }}
                        dangerouslySetInnerHTML={{ __html: form.NTT_CN || "" }}
                    />
                    )}
                </div>

                {/* 첨부 (읽기: 목록 / 수정: 업로드) */}
                {!isQna && (
                    <div className="col-12">
                        <label className="form-label">첨부파일</label>
                        {edit ? (
                            // 수정 모드 → 업로드/삭제 가능한 기존 AttachmentBox
                            <AttachmentBox
                            files={file || []}
                            onChange={(list) => setFile(list)}
                            />
                        ) : (
                            // 읽기 모드 → 업로드 UI 없이 목록만 보여주기
                            //(Array.isArray(form.ATCH_FILE) && form.ATCH_FILE.length > 0) ? (
                            (Array.isArray(file) && file.length > 0) ? (
                            <ul className="list-group list-group-flush">
                                {file.map((f, i) => (
                                <li
                                    key={f.ID || `${f.FILE_NM}-${i}`}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                    <div className="d-flex align-items-center gap-2">
                                    <i className="fa-solid fa-paperclip text-secondary" />
                                    {f.url ? (
                                        <a
                                        href={f.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        download={f.FILE_NM}
                                        className="link-dark text-decoration-none"
                                        >
                                        {f.FILE_NM || `첨부파일_${i + 1}`}
                                        </a>
                                    ) : (
                                        <span>{f.FILE_NM || `첨부파일_${i + 1}`}</span>
                                    )}
                                    {f.size != null && (
                                        <span className="text-muted small">({formatBytes(f.FILE_SIZE)})</span>
                                    )}
                                    </div>

                                    {f.url && (
                                    <a
                                        className="btn btn-sm btn-outline-secondary"
                                        href={f.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        download={f.FILE_NM}
                                    >
                                        <i className="fa-regular fa-download me-1" />
                                        다운로드
                                    </a>
                                    )}
                                </li>
                                ))}
                            </ul>
                            ) : (
                            <div className="form-control bg-light text-muted">
                                첨부파일이 없습니다.
                            </div>
                            )
                        )}
                        </div>
                    )}
                </form>
            </div>
        </div>
        {/* ✅ 상세창 안에서 뜨는 삭제 모달 */}
        <ConfirmModal
            show={askDelete}
            title="삭제 확인"
            message={`"${form?.NTT_SJ || "이 글"}"을 삭제하시겠습니까?`}
            onCancel={() => setAskDelete(false)}
            onConfirm={async () => { await deletePost(form); setAskDelete(false); onClose?.(); }}
            portalTarget={portalTarget}    // ✅ 추가
        />
    </div>
    );
    
}

export default function Boards() {
    // 게시판 목록 
    const [boardList, setBoardList] = useState(readSession(boardMasters));
    const [tab, setTab] = useState(boardList[0].BBS_ID);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);

    // ✅ 상태 필터 기본값 포함
    const [draft, setDraft] = useState({ keyword: "", from: "", to: "", status: "ALL" });
    const [filters, setFilters] = useState({ keyword: "", from: "", to: "", status: "ALL" });
    const onSearch = () => {
        setFilters({ ...draft });
        setPage(1);
    };

    const [detail, setDetail] = useState(null);
    const [confirmDel, setConfirmDel] = useState(null);
    const isQna = tab === "BBSMSTR_BBBBBBBBBBBB";

    currentBbsId = tab;

    const [items, setItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const articles = async () => {
        try {
            setError(null);
            setItems(null);
            setLoading(true);

            const url = "/scms/api/bbs/selectBoardArticle.do";
            const body = JSON.stringify({
                bbsId : tab,
            });
    
            apiAxios(url, body, function(res) {
                setItems(res.list);
            });
    
        } catch(e) {
            setError(e);
        }
        setLoading(false);
    };
    
    useEffect(() => {
        articles();
    }, [tab]);
    
    // 목록 (샘플)
    const data = useMemo(() => {
        if(items != null) {
            return items
            .filter((r) => r.BBS_ID === tab)
            .sort((a, b) => (a.REG_DT < b.REG_DT ? 1 : -1));
        } 
    }, [items, tab]);
    
    // ✅ 필터: 문의(Q&A)일 때만 상태 필터(STATE_CD) 적용
    const filtered = useMemo(() => {
        const kw = (filters.keyword || "").toLowerCase();
        if(data !== undefined && data !== null) {
            return (data || []).filter((r) => {
                if (kw) {
                    const bucket = `${r.NTT_SJ || ""} ${r.USER_NM || ""}`.toLowerCase();
                    if (!bucket.includes(kw)) return false;
                }
                const ymd = (r.REG_DT || "").slice(0, 10);
                if (filters.from && ymd < filters.from) return false;
                if (filters.to && ymd > filters.to) return false;

                // ✅ 상태 필터는 문의 탭에서만
                if (tab === "BBSMSTR_BBBBBBBBBBBB" && filters.status && filters.status !== "ALL") {
                    if ((r.STATE_CD || "") !== filters.status) return false;
                }
                return true;
            });
        }
    }, [data, filters, tab]);
    
    if(loading) return <div> Loading... </div>
    if(error) return <div> 에러가 발생했습니다. </div>

    if(!items) return null;
    if(!filtered) return <div> Filter is undefined. </div> 

    const total = filtered.length;
    const start = (page - 1) * size;
    const pageRows = filtered.slice(start, start + size);

    const openDetail = (row) => setDetail(row);
    const openNew = () =>
        setDetail({
        ID: null,
        type: tab,
        NTT_SJ: "",
        NTT_CN: "",
        ATCH_FILE: "",
        USER_NM: "관리자",
        REG_DT: today(),
    });

    return (
    <div className="cms-card">
        <div className="d-flex justify-content-between align-items-center mb-2">
            <ul className="nav nav-pills">
            {boardList.map((row) => (
                <li key={row.ID} className="nav-item">
                    <button
                    className={"nav-link" + (tab === row.BBS_ID ? " active" : "")}
                    onClick={() => {
                        setTab(row.BBS_ID);
                        setPage(1);
                    }}
                    >
                        {row.BBS_NM}
                    </button>
                </li>
            ))}
            </ul>
        </div>

        {/* 🔎 검색 필터 */}
        <div className="cms-card mb-3 filterBox">
            <div className="row g-2 align-items-end input-rounded">
            <form className="col-md-2 col-6">
                <label className="form-label mb-1">등록일</label>
                <input
                type="date"
                className="form-control form-control-sm"
                value={draft.from}
                onChange={(e) => setDraft({ ...draft, from: e.target.value })}
                />
            </form>

            {/* ✅ 상태 셀렉트는 문의 탭에서만 노출, 현재 그런 구분 없음 */}
            {/* {tab === "BBSMSTR_BBBBBBBBBBBB" && (
                <form className="col-md-2 col-6">
                    <label className="form-label mb-1">상태</label>
                    <select
                        className="form-select form-select-sm"
                        value={draft.status}
                        onChange={(e) => setDraft({ ...draft, status: e.target.value })}
                    >
                        <option value="ALL">전체</option>
                        <option value="게시중">게시중</option>
                        <option value="처리중">처리중</option>
                        <option value="완료">완료</option>
                    </select>
                </form>
            )} */} 

            <form className={tab === "BBSMSTR_BBBBBBBBBBBB" ? "col-md-5 col-8" : "col-md-7 col-8"}>
                <label className="form-label mb-1">제목/작성자</label>
                <input
                className="form-control form-control-sm"
                placeholder="제목 또는 작성자"
                value={draft.keyword}
                onChange={(e) => setDraft({ ...draft, keyword: e.target.value })}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
                />
            </form>

            <div className="col-md-3 col-4">
                <div className="d-flex gap-2 justify-content-end">
                    <button className="btn btn-sm btn-primary" onClick={onSearch}>
                        조회
                    </button>
                    {/* ✅ 공지 탭에서만 '등록' 노출 (문의 탭: 숨김) */}
                    {!isQna && (
                    <button className="btn btn-sm btn-outline-primary" onClick={openNew}>
                        <i className="fa-solid fa-plus me-1" />
                        등록
                    </button>
                    )}
                </div>
            </div>
            </div>
        </div>

        {/* 📋 목록 */}
        <table className="table table-hover table-rounded">
            <thead>
                <tr>
                    <th style={{ width: 80 }}>ID</th>
                    <th>{isQna ? "문의내용" : "제목"}</th>
                    <th style={{ width: 120 }}>작성자</th>
                    {isQna && <th style={{ width: 100 }}>회사명</th>}
                    {isQna && <th style={{ width: 100 }}>이메일</th>}
                    {/* ✅ 상태 컬럼: 문의 탭 전용 */}
                    {/* {isQna && <th style={{ width: 110 }}>상태</th>} */}

                    {!isQna && <th style={{ width: 90 }}>조회수</th>}
                    <th style={{ width: 150 }}>등록일</th>
                    <th style={{ width: 120 }}></th>
                </tr>
            </thead>
            <tbody>
                {pageRows.map((row) => (
                    <tr key={row.ID} style={{ cursor: "pointer" }} onClick={() => openDetail(row)} 
                        className="borderBottom">
                        <td>{row.ID}</td>
                        {/* 제목 ↔ 문의내용(텍스트 미리보기; HTML 태그 제거) */}
                        <td className="text-truncate">
                            {isQna
                                ? (row.NTT_CN || "").replace(/<[^>]+>/g, "").slice(0, 100)
                                : row.NTT_SJ}
                        </td>
                        <td className="text-muted small">{row.USER_NM}</td>
                        {/* 회사명 */}
                        {isQna && (
                            <td>
                            {row.NTCR_NM ? (
                                <span className="text-muted small">{row.NTCR_NM}</span>
                            ) : (
                                ""
                            )}
                            </td>
                        )}

                        {/* 이메일 */}
                        {isQna && (
                            <td>
                            {row.NTCR_ID ? (
                                <span className="text-muted small">{row.NTCR_ID}</span>
                            ) : (
                                ""
                            )}
                            </td>
                        )}

                        {/* ✅ 상태 값: 문의 탭 전용 (뱃지) */}
                        {/* {isQna && (
                            <td>
                            {row.STATE_CD ? (
                                <span
                                    className={
                                        "badge " +
                                        (row.STATE_CD === "완료"
                                            ? "badge-soft-success"
                                            : row.STATE_CD === "처리중"
                                            ? "badge-soft-warning"
                                            : "badge-soft")
                                    }
                                >
                                {row.STATE_CD}
                                </span>
                            ) : (
                                "-"
                            )}
                            </td>
                        )} */}

                        {/* <td>{row.RDCNT ? row.RDCNT : 0}</td> */}
                        {/* 조회수: 공지 탭 전용 */}
                        {!isQna && <td>{row.RDCNT ? row.RDCNT : 0}</td>}

                        <td className="text-muted small">{(row.REG_DT || "").slice(0, 16)}</td>
                        <td className="text-end" onClick={(e) => e.stopPropagation()}>
                            <div className="btn-group btn-group-sm">
                                <button className="btn btn-outline-secondary" onClick={() => openDetail(row)}>
                                    <i className="fa-regular fa-eye"></i>
                                </button>
                                <button className="btn btn-outline-danger" onClick={() => setConfirmDel(row)}>
                                    <i className="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}

                {!pageRows.length && (
                    <tr>
                        {/* 두 탭 모두 6열(문의: 상태 / 공지: 조회수) → colSpan 6로 통일 */}
                        <td colSpan={6} className="text-center text-muted py-5">
                            데이터가 없습니다.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>

        {/* 페이지네이션 */}
        <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted small">총 {total}건</div>
                <Paginator
                    page={page}
                    total={total}
                    size={size}
                    onPage={setPage}
                    onSize={(n) => {
                        setSize(n);
                        setPage(1);
                    }}
                />
            </div>

            {/* 상세 창 */}
            {detail && (
                <NewWindow title={detail?.ID ? "게시물 상세" : "게시물 등록"} onClose={() => setDetail(null)}>
                    {(portalTarget) => (
                    <PostDetailPanel
                        item={detail?.ID ? detail : null}
                        currentType={tab}
                        portalTarget={portalTarget}   // ✅ 추가
                        onClose={() => setDetail(null)}
                        onSaved={() => setDetail(null)}
                        onDeleted={() => setConfirmDel(detail)}
                    />
                    )}
                </NewWindow>
            )}
            {/* 목록에서 바로 삭제(보기/삭제 버튼 중 '삭제') */}
                <ConfirmModal
                    show={!!confirmDel}
                    title="삭제 확인"
                    message={`"${confirmDel?.TITLE || confirmDel?._SRC?.PMG_NM || "이 항목"}"을 삭제하시겠습니까?`}
                    onCancel={() => setConfirmDel(null)}
                    onConfirm={async () => {
                        const ok = await deletePost(confirmDel);   // ← 성공여부 받음
                    }}
                />
        </div>
    );
}
